import { Alert } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useFGLById from 'screens/stakeholders/hooks/queries/useFGLById';
import useMachineOwnerById from 'screens/stakeholders/hooks/queries/useMachineOwnerById';
import usePaddyBuyerById from 'screens/stakeholders/hooks/queries/usePaddyBuyerById';
import { Stakeholder } from 'types/common';

const VerificationWarning = ({
  data,
  type,
  style,
}: {
  data?: Stakeholder;
  type: 'PADDY_BUYER' | 'FARMER_GROUP_LEADER' | 'MACHINE_OWNER';
  style?: React.CSSProperties;
}) => {
  const { t } = useTranslation();
  const pbData = usePaddyBuyerById(data?.id, type === 'PADDY_BUYER');
  const fglData = useFGLById(data?.id, type === 'FARMER_GROUP_LEADER');
  const moData = useMachineOwnerById(data?.id, type === 'MACHINE_OWNER');

  const dataById = useMemo(() => {
    switch (type) {
      case 'PADDY_BUYER':
        return pbData;
      case 'FARMER_GROUP_LEADER':
        return fglData;
      case 'MACHINE_OWNER':
        return moData;
      default:
        return null;
    }
  }, [type, pbData, fglData, moData]);

  const latestVerificationLog = dataById?.data?.data?.dataVerificationLog?.[0];

  if (data?.dataVerifiedStatus || !latestVerificationLog) {
    return null;
  }

  return (
    <Alert
      style={{ padding: '12px 16px', ...style }}
      message={t('stakeholderVerification.verifiedWithIssues')}
      description={
        latestVerificationLog?.reason ||
        t('stakeholderVerification.noReasonProvided')
      }
      type="warning"
      showIcon
    />
  );
};

export default VerificationWarning;
